var chunkMapping = {
	"10809": [
		10809
	],
	"13542": [
		13542
	],
	"17649": [
		17649
	],
	"34598": [
		34598
	],
	"45776": [
		45776
	],
	"55060": [
		55060
	],
	"55133": [
		55133
	],
	"71653": [
		71653
	],
	"93021": [
		64987
	]
};
var idToExternalAndNameMapping = {
	"10809": [
		"default",
		"./query",
		71546
	],
	"13542": [
		"default",
		"./feature-flag",
		71546
	],
	"17649": [
		"default",
		"./logout",
		71546
	],
	"34598": [
		"default",
		"./content",
		71546
	],
	"45776": [
		"default",
		"./adobe",
		71546
	],
	"55060": [
		"default",
		"./provider",
		71546
	],
	"55133": [
		"default",
		"./auth",
		71546
	],
	"64987": [
		"default",
		"./dialog",
		71546
	],
	"71653": [
		"default",
		"./config",
		71546
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}